import React from 'react'

const VideoComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default VideoComponent
